import script from "./recommend.vue?vue&type=script&setup=true&name=Recommend&lang=js"
export * from "./recommend.vue?vue&type=script&setup=true&name=Recommend&lang=js"

import "./recommend.vue?vue&type=style&index=0&id=20b8f394&scoped=true&lang=css"
import "./recommend.vue?vue&type=style&index=1&id=20b8f394&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b8f394"]])

export default __exports__